/**
 * Source: https://lucide.dev/icons/message-circle
 * ISC licensed. Copyright (c) 2026 Lucide Icons and Contributors.
 */
import type {Icon} from '@primer/octicons-react'

import {CustomIcon} from './CustomIcon'

export const MessageCircleIcon: Icon = ({fill = 'currentColor', ...props}) => (
  <CustomIcon {...props} fill="none" naturalWidth={24} naturalHeight={24}>
    <path
      d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"
      // `CustomIcon` sets `class="octicon"`, and Primer's global `.octicon` rule sets
      // `fill: currentColor`. A CSS declaration beats the `fill="none"` presentation
      // attribute on the `<svg>`, which would fill this outline glyph solid wherever
      // that stylesheet loads. The rule targets the `<svg>`, so keeping `fill` on the
      // `<path>` wins over the inherited value.
      fill="none"
      stroke={fill}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </CustomIcon>
)
